import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="monitoring--time-line"
export default class extends Controller {
    static targets = ["selectTime"];

    connect() {
    }

    handleTimeSelection(event) {
        let to = Math.floor(new Date().getTime() / 1000)
        let from = to - this.convertTimeToSecond(event.currentTarget.value)

        this.dispatch("updateTime", {
            detail: {from, to},
            bubbles: true
        });
    }

    convertTimeToSecond(time) {
        if (time === '5m') {
            return 5 * 60
        }
        if (time === '30m') {
            return 30 * 60
        }
        if (time === '1h') {
            return 60 * 60
        }
        if (time === '4h') {
            return 4 * 60 * 60
        }
        if (time === '12h') {
            return 12 * 60 * 60
        }
        if (time === '1d') {
            return 24 * 60 * 60
        }
        if (time === '7d') {
            return 24 * 7 * 60 * 60
        }
        if (time === '31d') {
            return 24 * 31 * 60 * 60
        }
        if (time === '1y') {
            return 24 * 365 * 60 * 60
        }
    }

}
